import {Component} from '@angular/core';
import {App, NavController, NavParams} from 'ionic-angular';
import {SocialService} from "../../providers/social-service";
import {StorageService} from "../../providers/storage";
import {Tweets} from "../tweets/tweets";

@Component({
  selector: 'page-twitter-login',
  templateUrl: 'twitter-login.html',
})
export class TwitterLogin {

  public pin: string;
  private idReq;
  public authUrl: string = '';

  constructor(
    //public navCtrl: NavController,
    //public navParams: NavParams,
    private socialService: SocialService,
    private storageService: StorageService,
    public app: App
  ) {}

  ionViewDidLoad() {
    this.socialService.auth_url()
      .subscribe((data: any) => {
        this.authUrl = data.authUrl;
        this.idReq = data.idReq;
      }, (err) => {
        // console.log(err)
      });
  }

  public savePin() {
    this.socialService.store_twitter_pin(this.storageService.get('userId'), this.idReq, this.pin)
      .subscribe((data) => {
        if (data.userId == 0) {
          // operazione fallita, invitare l'utente a riprovare
        } else {
          this.storageService.set('socialEnabled', true);
          // operazione eseguita, salvo i dati
          this.socialService.login(this.storageService.get('userId'));
          this.storageService.set('socialUserId', data.userId);

          // redirect verso la pagina principale di twitter coi vari tweet
          let nav = this.app.getRootNav();
          nav.setRoot(Tweets);
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/twitter-login/twitter-login.ts